import React, { memo } from 'react';
import { Icon, Popover, useTheme } from '@Sage/hoi-poi-ui';

import ReadOnlyTooltipContent from './ReadOnlyTooltipContent';

import './styles.scss';

/**
 * Renders a lock icon next to the entity title in detail headers and list rows
 * when a record is not editable by the current user (GOKU-11242).
 *
 * Only renders when `isReadOnly` is true. For public Companies that are also
 * readonly, use `PublicAccountIndicator` instead; this component only covers
 * the non-public case.
 */
const ReadOnlyIndicator = memo(({ isReadOnly, isPublicCompany = false, className }) => {
    const theme = useTheme();

    if (!isReadOnly) return null;

    return (
        <Popover
            className="fm-readonly-indicator"
            placement="bottom"
            content={<ReadOnlyTooltipContent isPublicCompany={isPublicCompany} />}
            trigger={['hover']}
        >
            <div className={`fm-readonly-indicator__icon ${className || ''}`.trim()}>
                <Icon name="lock" color={theme.colors.grey[500]} />
            </div>
        </Popover>
    );
});

export default ReadOnlyIndicator;
